import React, { Suspense, lazy } from 'react';
import { TopBanner } from './components/TopBanner';
import { HeroSection } from './components/HeroSection';
import { StickyOfferButton } from './components/StickyOfferButton';
// Lazy load below-the-fold components
const ComparisonTable = lazy(() => import('./components/ComparisonTable').then(m => ({
  default: m.ComparisonTable
})));
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SuccessStories = lazy(() => import('./components/SuccessStories').then(m => ({
  default: m.SuccessStories
})));
const ProjectCarousel = lazy(() => import('./components/ProjectCarousel').then(m => ({
  default: m.ProjectCarousel
})));
const WhatYouGet = lazy(() => import('./components/WhatYouGet').then(m => ({
  default: m.WhatYouGet
})));
const BonusGrid = lazy(() => import('./components/BonusGrid').then(m => ({
  default: m.BonusGrid
})));
const ImpactShowcase = lazy(() => import('./components/ImpactShowcase').then(m => ({
  default: m.ImpactShowcase
})));
const AntiScamSection = lazy(() => import('./components/AntiScamSection').then(m => ({
  default: m.AntiScamSection
})));
const PriceBox = lazy(() => import('./components/PriceBox').then(m => ({
  default: m.PriceBox
})));
const CommentsSection = lazy(() => import('./components/CommentsSection').then(m => ({
  default: m.CommentsSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const FAQSection = lazy(() => import('./components/FAQSection').then(m => ({
  default: m.FAQSection
})));
const MetaPixel = lazy(() => import('./components/MetaPixel').then(m => ({
  default: m.MetaPixel
})));
export function App() {
  return <div className="min-h-screen bg-transparent font-sans selection:bg-[#ec4899]/30 selection:text-white text-white" data-id="element-0">
      <Suspense fallback={null} data-id="element-1">
        <MetaPixel data-id="element-2" />
      </Suspense>
      <TopBanner data-id="element-3" />
      <StickyOfferButton data-id="element-4" />

      <main className="flex flex-col" data-id="element-5">
        <HeroSection data-id="element-6" />

        <Suspense fallback={<div className="min-h-[400px]" data-id="element-8" />} data-id="element-7">
          <ComparisonTable data-id="element-9" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-11" />} data-id="element-10">
          <ProblemSection data-id="element-12" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-14" />} data-id="element-13">
          <SuccessStories data-id="element-15" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[500px]" data-id="element-17" />} data-id="element-16">
          <ProjectCarousel data-id="element-18" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-20" />} data-id="element-19">
          <WhatYouGet data-id="element-21" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-23" />} data-id="element-22">
          <BonusGrid data-id="element-24" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[500px]" data-id="element-26" />} data-id="element-25">
          <ImpactShowcase data-id="element-27" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-29" />} data-id="element-28">
          <AntiScamSection data-id="element-30" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[1000px]" data-id="element-32" />} data-id="element-31">
          <PriceBox data-id="element-33" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[800px]" data-id="element-35" />} data-id="element-34">
          <CommentsSection data-id="element-36" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-38" />} data-id="element-37">
          <TestimonialsSection data-id="element-39" />
        </Suspense>

        <Suspense fallback={<div className="min-h-[600px]" data-id="element-41" />} data-id="element-40">
          <FAQSection data-id="element-42" />
        </Suspense>
      </main>

      <footer className="bg-transparent py-12 border-t border-[#27272a] text-center" role="contentinfo" data-id="element-43">
        <div className="max-w-7xl mx-auto px-4" data-id="element-44">
          <p className="text-gray-400 text-sm mb-2" data-id="element-45">
            © 2026 Neon Flex Academy. Todos los derechos reservados.
          </p>
          <p className="text-gray-400 text-sm mb-4" data-id="element-46">
            Soporte:{' '}
            <a href="mailto:soportesinfinstudio@gmail.com" className="hover:text-white transition-colors" data-id="element-47">
              soportesinfinstudio@gmail.com
            </a>
          </p>
          <p className="text-gray-400 text-xs max-w-2xl mx-auto leading-relaxed" data-id="element-48">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>
    </div>;
}